'use strict';

angular.module('amexReconciliationApp')
    .component('notificationsModal', {
        templateUrl: 'scripts/views/modals/notifications-modal.html',
        bindings: {
            closeModalCallback: '&',
            currentPage:'@'
        },
        controller: function (NotificationsRepository,$filter) {
            var self = this;
            self.notifications = [];
            self.notificationIndex = 0;

            self.$onInit = function () {
                self.notifications = [];
                self.notifications = $filter('orderBy')(NotificationsRepository.notifications,'lastUpdatedDate',true);
                self.closeModal = self.closeModalCallback;
            };

            self.previousNotification = function(){
                self.notificationIndex-=1;
            };

            self.nextNotification = function(){
                self.notificationIndex+=1;
            };

        }
    });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/notificationsModal.js
// module id = 462
// module chunks = 0